
import { SVGProps } from "react";
import { twMerge } from "tailwind-merge";

export function RefreshIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={twMerge(
        className
      )}
      {...props}
      width="24" height="25" viewBox="0 0 24 25">
      <path d="M3 3.5V9.5M3 9.5H9M3 9.5C5.32744 7.41141 7.48287 5.04676 10.7453 4.58779C12.6777 4.31593 14.6461 4.67941 16.3539 5.62343C18.0617 6.56746 19.4164 8.04091 20.2139 9.82177M21 21.5V15.5M21 15.5H15M21 15.5C18.6725 17.5886 16.5171 19.9532 13.2546 20.4122C11.3223 20.6841 9.35388 20.3206 7.64607 19.3766C5.93826 18.4325 4.58353 16.9591 3.78601 15.1782" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
